import Reflux from 'reflux';

const DashboardActions = Reflux.createActions([
  'read',
  'readComplete',
  'editCourse',
  'addCourseSkeleton',
  'saveCourse',
  'createCourseComplete',
  'updateCourseComplete',
  'removeCourse',
  'removeCourseCompleted',
  'initQuizSection',
  'duplicateCourse',
  'duplicateCourseComplete',
  'setSortMethod'
]);

export default DashboardActions;



// WEBPACK FOOTER //
// ./src/js/actions/Dashboard.js